import _ from "lodash"

export function findPlanbookDatesOff(newAnnotations) {
  let defaultDatesOff = _.chain(newAnnotations)
    .filter((annotation) => annotation.type === "date-annotation-planbook-default")
    .filter((annotation) => annotation.attributes.isOff === true)
    .map((annotation) => `${annotation.attributes.semesterId}:${annotation.attributes.rotationId}`)
    .value()

  let customRangesOff = _.chain(newAnnotations)
    .filter((annotation) => annotation.type === "date-annotation-planbook-custom-range")
    .filter((annotation) => annotation.attributes.isOff === true)
    .flatMap((annotation) =>
      dateFns.eachDay(annotation.attributes.startDate, annotation.attributes.endDate)
    )
    .map((dateObject) => dateFns.format(dateObject, "YYYY-MM-DD"))
    .value()

  let customDatesOff = _.chain(newAnnotations)
    .filter((annotation) => annotation.type === "date-annotation-planbook-custom-single")
    .filter((annotation) => annotation.attributes.isOff === true)
    .map((annotation) => annotation.attributes.dateString)
    .value()

  return _.sortBy(_.uniq(defaultDatesOff.concat(customRangesOff).concat(customDatesOff)))
}

export function findCourseDatesOff(newAnnotations) {
  let defaultDatesOff = _.chain(newAnnotations)
    .filter((annotation) => annotation.type === "date-annotation-course-default")
    .filter((annotation) => annotation.attributes.isOff === true)
    .map((annotation) => `${annotation.attributes.semesterId}:${annotation.attributes.rotationId}`)
    .value()

  let customDatesOff = _.chain(newAnnotations)
    .filter((annotation) => annotation.type === "date-annotation-course-custom-single")
    .filter((annotation) => annotation.attributes.isOff === true)
    .map((annotation) => annotation.attributes.dateString)
    .value()

  return _.sortBy(_.uniq(defaultDatesOff.concat(customDatesOff)))
}
